import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class ReportService {
  async getUsageReport(options) {
    const queryParameters = Object.keys(options)
      .map((key) => `${key}=${options[key]}`)
      .join("&");

    return (await fetchApi.get(`/report/job/list?${queryParameters}`)).data;
  }

  async getMetrics() {
    return (await fetchApi.get(`/report/job/metrics`)).data;
  }

  async getContainerDetails() {
    return (await fetchApi.get(`/report/job/container-info`)).data;
  }

  async getDataAITopWorkspaces(options) {
    const queryParameters = Object.keys(options)
      .map((key) => `${key}=${options[key]}`)
      .join("&");

    return (await fetchApi.get(`/report/data-ai/workspace?${queryParameters}`)).data;
  }

  async getDataAITopUsers() {
    return (await fetchApi.get(`/report/data-ai/user`)).data;
  }

  async getWorkspaceAccess(submitData) {
    return (await fetchApi.post(`/report/workspace-access/list`, submitData)).data;
  }

  async exportAccessReport(submitData, onSuccess) {
    const now = new Date();
    const dateStr = `${now.getMonth() + 1}-${now.getDate()}-${now.getFullYear()}`;
    const formattedDate = `${dateStr} ${now.getHours()}-${now.getMinutes()}`;
    const filename = `VORTEX Workspace Access Report ${formattedDate}.csv`;

    return await fetchApi.downloadPost(`/report/workspace-access/export-list`, submitData, filename, onSuccess);
  }
}
